import { create } from "zustand"

import type { PaymentTerm, PaymentTermListQuery, PaymentTermSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { PaymentTermListDocument } from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type PaymentTermSearchFilters = SearchFilters & {
  field?: PaymentTermSortField
  order?: SortingOrder
}

const deduplicateData = (newData: PaymentTerm[], existingData: PaymentTerm[]): PaymentTerm[] => {
  const uniqueIds = new Set(existingData.map((paymentTerm) => paymentTerm.paymentTermId))
  return [...existingData, ...newData.filter((paymentTerm) => !uniqueIds.has(paymentTerm.paymentTermId))]
}

export const usePaymentTermSearchStore = create(
  createSearchStore<PaymentTerm, PaymentTermSearchFilters, PaymentTermListQuery>({
    documentNode: PaymentTermListDocument,
    deduplicateData,
    getQueryInput: (filters: PaymentTermSearchFilters, offset: number, limit: number) => {
      const { field, order } = filters
      return {
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.paymentTerm.list.__typename,
      data:
        data?.paymentTerm.list.__typename === "PaymentTermListSuccess"
          ? (data.paymentTerm.list.paymentTerms as PaymentTerm[])
          : [],
      error: data?.paymentTerm.list.__typename === "PaymentTermListFailure" ? data.paymentTerm.list.error : undefined,
    }),
  })
)
